<template>
  <div class="product-congratulations" :class="{desktop: !mediaQueries.mobileSize}">
    <div @click="close" class="c-overlay" :class="{fadeIn: toggle, fadeOut: !toggle}"></div>
    <div class="content">
      <div class="mini-overlay" :class="{fadeIn: toggle, fadeOut: !toggle}"></div>
      <div class="real-content" :class="{bottomToTop: toggle, topToBottom: !toggle}">
        <div class="close-container">
          <div @click="close" class="close"></div>
        </div>
        <span v-if="mediaQueries.mobileSize" class="message mt-4">برای زوم روی عکس دوبار ضربه بزنید</span>
        <span v-else class="message mt-4">برای زوم روی عکس دوبار ضربه بزنید و یا اسکرول کنید</span>
        <button @click="close" class="btn see-cart-btn text-black">باشه!</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Help",
  props: {
    value: Boolean
  },
  inject: ['mediaQueries'],
  data() {
    return {
      toggle: true,
      animationTimeout: '300' // In ms, also change variable in style
    }
  },
  mounted() {
  },
  methods: {
    close() {
      if (!this.toggle) {
        return
      }
      this.toggle = false;
      setTimeout(() => {
        this.$emit('input', false)
      }, this.animationTimeout)
    }
  }
}
</script>

<style lang="scss" scoped>
$animation-timeout:300ms;
$modal-height:170px;
.product-congratulations {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 999;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  overflow: hidden;
}

.product-congratulations.desktop {
  max-width: 500px;
  left: 0;
  transform: translateX(50%);
  right: 50%;
  justify-content: flex-end;
  overflow: visible;
}

.c-overlay {
  flex-grow: 1;
  background: black;
  opacity: 0.5;
}

.desktop .c-overlay {
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  width: 300vw;
  height: 100vh;
  transform: translateX(50%);
}

.content {
  position: relative;
  height: $modal-height;
}

.real-content {
  height: 100%;
  background: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px;
  z-index: 2;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
}

.mini-overlay {
  height: $modal-height;
  width: 100%;
  background: black;
  opacity: 0.5;
  position: absolute;
  bottom: 0;
}

.desktop .mini-overlay {
  opacity: 0;
  display: none;
}

.close {
  position: absolute;
  width: 20%;
  top: -8px;
  height: 3px;
  border-radius: 5px;
  background-color: #b3b3b3;
  z-index: 3;
  left: 50%;
  transform: translateX(-50%);
}

.close-container {
  position: relative;
  width: 100%;
  height: 1px;
}


.continue-btn {
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
  text-decoration: none;
  display: block;
  width: 91.2%;
  padding: 13px 5px;
  background-color: white;
  border: 1px solid #c1c1c1;
  color: #313131;
  margin: auto;
  margin-bottom: 10px;
}

.see-cart-btn {
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
  text-decoration: none;
  display: block;
  width: 91.2%;
  padding: 15px 5px;
  background-color: var(--color-theme);
  color: white;
  margin: auto;
}

@keyframes bottomToTopAnimation {
  from {
    bottom: -100%;
  }
  to {
    bottom: 0;
  }
}

@keyframes topToBottomAnimation {
  from {
    bottom: 0;
  }
  to {
    bottom: -100%;
  }
}

@keyframes fadeOutAnimation {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 0;
  }
}

@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}

.topToBottom {
  animation:$animation-timeout topToBottomAnimation;
}

.bottomToTop {
  animation: $animation-timeout bottomToTopAnimation;
}

.fadeOut {
  animation: $animation-timeout fadeOutAnimation;
}


.fadeIn {
  animation: $animation-timeout fadeInAnimation;
}

.message {
  display: block;
  margin-bottom: 1rem;
}
</style>


